export default {
    video1: null,
    video2: null,
    param: {
        
    }
};